import { Title } from "./SectionTitle.styled";

export const SectionTitle = ({ title, textAlign = "center", addStyles }) => (
  <Title textAlign={textAlign} addStyles={addStyles}>
    {title}
  </Title>
);
